<template lang="pug">
  base-side-nav(:items='menuItems')
</template>

<script>
import BaseSideNav from "@/shared/components/BaseSideNav";

export default {
  components: { BaseSideNav },
  data() {
    return {
      menuItems: [
        {
          label: "Dashboard",
          icon: "home",
          routeName: "itrain:dashboard",
          subNav: []
        },
        {
          label: "Programs",
          icon: "list",
          subNav: [
            { label: "View all", routeName: "itrain:programList" },
            { label: "Add new", routeName: "itrain:programCreate" }
          ]
        },
        {
          label: "Courses",
          icon: "puzzle-piece",
          subNav: [
            { label: "View all", routeName: "itrain:courseList" },
            { label: "Add new", routeName: "itrain:courseCreate" }
          ]
        },
        {
          label: "Report",
          icon: "tachometer-alt",
          subNav: [
            // { label: "Program report", routeName: "itrain:courseList" },
            { label: "Course report", routeName: "itrain:coursesReport" },
            { label: "User report", routeName: "itrain:usersReportList" }
          ]
        },
        {
          label: "Notifications",
          icon: "bell",
          subNav: [
            { label: "Send to users", routeName: "itrain:notifications" }
          ]
        }
      ]
    };
  }
};
</script>
